// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const thundurus_incarnate: PokeData = {
  "id": 642,
  "name": "thundurus-incarnate",
  "height": 15,
  "weight": 610,
  "base_experience": 261,
  "types": [
    PokeType.ELECTRIC,
    PokeType.FLYING
  ],
  "api_moves": [
    "tackle",
    "thrash",
    "leer",
    "bite",
    "thunder-shock",
    "thunder",
    "agility",
    "swagger",
    "spark",
    "twister",
    "rain-dance",
    "crunch",
    "uproar",
    "charge",
    "revenge",
    "astonish",
    "extrasensory",
    "shock-wave",
    "hammer-arm",
    "heal-block",
    "dark-pulse",
    "nasty-plot",
    "discharge",
    "volt-switch",
    "wildbolt-storm"
  ],
  "moves": [
    "tackle",
    "leer",
    "bite",
    "thunder-shock",
    "thunder",
    "rain-dance",
    "crunch",
    "dark-pulse",
    "volt-switch",
    "tailwind",
    "sky-attack",
    "air-slash",
    "electric-terrain"
  ],
  "evolution_chain": {
    "id": 329,
    "item": null,
    "species": [
      {
        "name": "thundurus",
        "order": 643,
        "types": [
          PokeType.ELECTRIC,
          PokeType.FLYING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 98,
    "speed": 142,
    "ability_power": 160
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
